export default __webpack_public_path__ + "static/media/Logo-No-Background-White-Text.2ed888e6.png";